/**
 * Presents a UI suited for viewing permissions associated with a selected consumer.
 * @module app/views/admin/permissions/InverseViewer
 */
import Backbone from "backbone";
import _ from "underscore";
import Permission from "app/models/Permission";
import PermissionUtil from "@HBKEngineering/permission-util";
import Field from "core/models/Field";
import CollectionTableView from "core/views/CollectionTableView";
import SelectView from "core/views/SelectView";
import $ from "jquery";
import ErrorUtils from "app/utils/ErrorUtils";
import ViewHelper from "app/views/admin/permissions/ViewerHelper";
import urlService from "app/UrlService";

//yay hard-coding!
function consumerMetadata(key) {
  var metadata = {
    User: {
      nameField: "Username",
      urlBase: urlService.apiurl("/user/"),
      navBase: function (id) {
        return urlService.url("/admin/users/Details/") + id;
      },
    },
    Group: {
      nameField: "name",
      urlBase: urlService.apiurl("/groups/"),
      navBase: function (id) {
        return urlService.url("/admin/groups/Details/") + id;
      },
    },
  };

  return metadata[key];
}

export default Backbone.View.extend({
  /**
   * Initializes the interface.
   * @param  {object} options The options hash.
   * @param {GroupCollection} options.groups A set of `Group` models to use in searching for a consumer.
   * @param {UserCollection} options.users A set of `User` models to use in searching for a consumer.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      mapServices: new Backbone.Collection([]),
      groups: new Backbone.Collection([]),
    });
  },

  className: "permissions-inverse-viewer",

  template: _.template(
    '<div class="permission-search-container"></div>' +
      '<div class="permission-section global-section">' +
      '<h1>Global</h1><div class="permission-section public-section"><h2>Public Permissions</h2></div>' +
      '<div class="permission-section groups-section"><h2>Group Permissions</h2></div>' +
      '<div class="permission-section users-section"><h2>User Permissions</h2></div>' +
      '</div><div class="permission-section type-section">' +
      '<h1>Type</h1><div class="permission-section public-section"><h2>Public Permissions</h2></div>' +
      '<div class="permission-section groups-section"><h2>Group Permissions</h2></div>' +
      '<div class="permission-section users-section"><h2>User Permissions</h2></div>' +
      '</div><div class="permission-section item-section">' +
      '<h1>Item</h1><div class="permission-section public-section"><h2>Public Permissions</h2></div>' +
      '<div class="permission-section groups-section"><h2>Group Permissions</h2></div>' +
      '<div class="permission-section users-section"><h2>User Permissions</h2></div>' +
      "</div>"
  ),

  render: function () {
    this.$el.html(this.template(this.options));
    this._clearResults();
    this.select();
    var self = this;
    var serviceEntries = _.map(this.options.mapServices.models, function (
      MapService
    ) {
      return {
        label: "(MapService) " + MapService.get("name"),
        value: MapService.id,
      };
    });
    var layoutEntries = _.map(this.options.layerConfiguration.models, function (
      layerConfiguration
    ) {
      return {
        label: "(Layout) " + layerConfiguration.get("name"),
        value: layerConfiguration.id,
      };
    });

    self.serviceEntries = _.sortBy(serviceEntries, "label");
    self.layoutEntries = _.sortBy(layoutEntries, "label");

    var selectType = new SelectView({
      // need to create a select view with the mapservices, and layouts
      items: _.map(
        [
          {
            label: "Select Item Type...",
            value: "selectType",
          },
          {
            label: "MapService",
            value: "MapService",
          },
          {
            label: "Layout",
            value: "Layout",
          },
        ],
        function (entry) {
          return {
            text: entry.label,
            value: entry.value,
          };
        }
      ),
    });

    selectType.render();
    selectType.on("change", self.selectType, self);

    self.$(".permission-search-container").append(selectType.$el);
  },

  getServices: function () {
    var deferred = new $.Deferred();

    return $.when(deferred);
  },

  /**
   * Displays either the MapServices in a selectbox or the layouts depending on which is selected
   * @param  {string} producerId The id of the producer to select.
   */
  selectType: function (type) {
    var self = this;

    if (type == "MapService") {
      self._clearResults();
      self.selectView = new SelectView({
        // need to create a select view with the mapservices, layouts
        items: _.map(self.serviceEntries, function (entry) {
          return {
            text: entry.label,
            value: entry.value,
          };
        }),
        class: "serviceLayouts",
      });
    } else if (type == "Layout") {
      self._clearResults();
      self.selectView = new SelectView({
        // need to create a select view with the mapservices, layouts
        items: _.map(self.layoutEntries, function (entry) {
          return {
            text: entry.label,
            value: entry.value,
          };
        }),
        class: "serviceLayouts",
      });
    } else if (type == "selectType") {
      self._clearResults();
    }

    if (self.$(".serviceLayouts")) {
      self.$(".serviceLayouts").remove();
    }

    if (type != "selectType") {
      self.selectView.render();
      self.selectView.on("change", self.select, self);
      self.$(".permission-search-container").append(self.selectView.$el);
    }
  },

  /**
   * Displays the permissions for the given consumer.
   * @param  {string} producerId The id of the producer to select.
   */
  select: function (producerId) {
    this._clearResults();
    var self = this;

    if (producerId) {
      Permission.findInverse({
        MapService: producerId,
      })
        .done(function (data) {
          self.renderData(data);
        })
        .fail(
          ErrorUtils.errorHandler({
            activity: "loading the permissions",
          })
        );
    }
  },

  /**
   * Clears search results.
   */
  _clearResults: function () {
    this.$(".permission-section").hide();
    this.$(".permission-section h3, .permission-section table").remove();
  },

  renderData: function (data) {
    //Sections: Global, Type, Item
    //Within each section: Public, Group, User
    //Within public is a table with a single row which specifies Public|<allowed actions>|<prohibited actions>
    //Within group and user subsections are tables with: <link to user/group>|<allowed actions>|<prohibited actions>
    var sections = ["global", "type", "item"];
    var subSections = ["public", "groups", "users"];
    var self = this;
    //add a table with a single row here for Public|<allowed actions>|<prohibited actions>
    //first get the data
    this.PermissionSetModel = Backbone.Model.extend({
      initialize: function (options) {
        this.permissionSet = options.permissionSet;
        this.id = options.id;
      },
      typeDisplay: function () {
        var type = PermissionUtil.parseType(this.get("type")).type;

        return type || "*";
      },

      groupLink: function () {
        return this.id;
      },

      userLink: function () {
        return this.id;
      },

      allowedValues: function () {
        var actions = this.permissionSet;
        var results = _.keys(actions);

        results = _.filter(results, function (action) {
          return actions[action] ? true : false;
        });

        return results.join(", ");
      },

      deniedValues: function () {
        var actions = this.permissionSet;
        var results = _.keys(actions);

        results = _.filter(results, function (action) {
          return actions[action] ? false : true;
        });

        return results.join(", ");
      },
    });

    this.PermissionSetCollection = Backbone.Collection.extend({
      model: self.PermissionSetModel,
    });

    this.fieldGroup = new Field({
      id: "groupLink",
      name: "groupLink",
      label: "Group",
      editor: "custom",
      ViewerView: {
        loadingTemplate: _.template(
          '<span class="field-loading">Loading...</span>'
        ),

        errorTemplate: _.template('<span class="field-error">Not Found</span>'),

        template: _.template(
          '<% if(navUrl) {%><a href="<%- navUrl%>"><%-name%></a><%} else {%><%- name%><%}%>'
        ),

        startLoad: function () {
          var metadata = consumerMetadata("Group");
          var modelValue = this.options.value;

          return ViewHelper.loadMetadata(metadata, modelValue);
        },
      },
    });

    this.fieldUser = new Field({
      id: "userLink",
      name: "userLink",
      label: "User",
      editor: "custom",
      ViewerView: {
        loadingTemplate: _.template(
          '<span class="field-loading">Loading...</span>'
        ),

        errorTemplate: _.template('<span class="field-error">Not Found</span>'),

        template: _.template(
          '<% if(navUrl) {%><a href="<%- navUrl%>"><%-name%></a><%} else {%><%- name%><%}%>'
        ),

        startLoad: function () {
          var metadata = consumerMetadata("User");
          var modelValue = this.options.value;

          return ViewHelper.loadMetadata(metadata, modelValue);
        },
      },
    });

    this.fields = [
      new Field({
        id: "allowedValues",
        name: "allowedValues",
        label: "Allowed Actions",
        sortable: false,
        filterable: false,
      }),

      new Field({
        id: "deniedValues",
        name: "deniedValues",
        label: "Prohibited Actions",
        sortable: false,
        filterable: false,
      }),
    ];
    //display public section
    //public-section
    _.each(sections, function (section, index, list) {
      _.each(subSections, function (subSection, index, list) {
        if (data[section][subSection]) {
          //generate the table and append to the section and subsection
          var selector =
            "." + section + "-section > " + "." + subSection + "-section";
          var table = self.buildTable(
            null,
            section,
            subSection,
            index,
            data[section][subSection]
          );

          if (table) {
            self.$("." + section + "-section").show();
            self.$(selector).show();
            self.$(selector).append(table.$el);
          }
          self.$(".global-section").append();
        }
      });
    });
  },
  getType: function () {
    return "MapService";
  },

  buildTable: function (permissionSet, section, subSection, index, data) {
    var self = this;
    var type = self.getType();
    var modelCollection;
    var tableView;

    if (subSection == "groups") {
      self.fields.unshift(this.fieldGroup);
    } else if (subSection == "users") {
      self.fields.unshift(this.fieldUser);
    } else {
      //subSection = public
      permissionSet = data; // the public section doesn't contain the user groups objects
    }

    modelCollection = new self.PermissionSetCollection([]);

    if (JSON.stringify(data) != "{}" || permissionSet) {
      if (data && !permissionSet) {
        _.each(data, function (value, index, list) {
          modelCollection.add(
            new self.PermissionSetModel({
              type: type,
              permissionSet: value,
              id: index,
            })
          );
        });
      } else if (permissionSet) {
        modelCollection.add(
          new self.PermissionSetModel({
            type: type,
            permissionSet: permissionSet,
            id: index,
          })
        );
      }

      tableView = new CollectionTableView({
        fields: self.fields,
        collection: modelCollection,
        allowSave: false,
        allowDelete: false,
        mode: "view",
      });
      tableView.render();
    }

    if (subSection != "public") {
      self.fields.shift();
    }

    return tableView;
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/permissions/InverseViewer.js
// module id = 919
// module chunks = 1